import React, { Component } from 'react';

export class UnderConstruction extends Component {
    static displayName = UnderConstruction.name;

    constructor(props) {
        super(props);
       // this.toggle = this.toggle.bind(this);
        this.state = {
            loading: true,
            
        }
    }

    

    componentDidMount() {
        this.getCat();
    }

    

    render() {
        return (
            <div>
                <h1>We're sorry, but this isn't available yet.</h1>
                <br />
                Don't worry, we're working very hard to get this up and running. 
            </div>
            )
    }
}